import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import './NewServiceWorkSignupModal.css';
import { getShowNewServiceWorkModal } from '../../../selectors/admin/sidebar/sidebar';
import { toggleNewServiceWorkModal } from '../../../actions/admin/sidebar/sidebar.js';
import closePng from 'images/close.png';
import { getCurrentUser } from 'selectors/authentication';

class NewServiceWorkSignupModal extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    currentUser: PropTypes.object,
    currentCompany: PropTypes.object,
  };

  handleClose = () => {
    this.props.dispatch(toggleNewServiceWorkModal());
  };

  buildParams = () => {
    const user = this.props.currentUser;
    const company = this.props.currentCompany || { name: '', id: '' };
    const fields = [
      `569ni=${company.id}`,
      `825b7=${company.name}`,
      `8vn45=${user.accountable_type}`,
      `3751f=${user.first_name}`,
      `11g0m=${user.last_name}`,
      `6v740=${user.email}`,
      `7bi7q=${user.phone_number}`,
    ];
    return fields.join('&');
  };

  render() {
    const script = document.createElement('script');
    script.src = 'https://paperform.co/__embed';
    document.body.appendChild(script);
    return (
      <Modal
        className={'new-service-work-modal'}
        show={this.props.show}
        title={'New Service Work Coming Soon!'}
        onClose={() => {}}
      >
        <span className="close-icon">
          <img src={closePng} alt="close" onClick={this.handleClose} />
        </span>
        <div className="modal-header">
          <h2>
            <span className="modal-underline">Join</span> SPACKLE
          </h2>
          <div className="modal-body">
            Make your life exponentially easier
            <span className="modal-emphasis">.</span>
            <br />
            SPACKLE is a marketplace designed for building owners, facility
            managers and occupiers to connect with qualified contractors,
            automating the entire process of searching and hiring for small
            construction projects and service work.
            <br />
            <div className="modal-cta">
              <span className="modal-emphasis">
                Sign-up here to join the network and get to work!
              </span>
            </div>
          </div>
        </div>
        <div
          className="modal-paperform"
          data-prefill={this.buildParams()}
          data-paperform-id="iaiercyx"
        ></div>
      </Modal>
    );
  }
}

export default connect((state) => {
  return {
    show: getShowNewServiceWorkModal(state),
    currentUser: getCurrentUser(state),
  };
})(NewServiceWorkSignupModal);



// WEBPACK FOOTER //
// ./src/components/shared/modal/NewServiceWorkSignupModal.js